import * as types from './actionTypes';
import blogService from '../services/blogService';
import { fetch, addTask } from 'domain-task';
import articleTypes from '../constants/articleTypes';
import ShareService from '../services/shareService';

function dispatchStatusUpdate(dispatch, type, page, status) {
    let loadingStatus = { page, status };
    dispatch({ type, loadingStatus });
}

function dispatchArticleStatusUpdate(dispatch, type, status) {
    let loadingStatus = { status };
    dispatch({ type, loadingStatus });
}

const getActionTypeSet = (articleType) => {
    if(articleType == articleTypes.general) {
        return types.GET_BLOG_GENERAL;
    } 
    else if(articleType == articleTypes.unsigned) {
        return types.GET_BLOG_UNSIGNED;
    }
    else {
        return types.GET_BLOG_DISCOVER;
    }
};

const getActionTypeStatus = (articleType) => {
    if(articleType == articleTypes.general) {
        return types.GET_BLOG_GENERAL_STATUS;
    } 
    else if(articleType == articleTypes.unsigned) {
        return types.GET_BLOG_UNSIGNED_STATUS;
    }
    else {
        return types.GET_BLOG_DISCOVER_STATUS;
    }
};

const getActionTypeTags = (articleType) => {
    if(articleType == articleTypes.general) {
        return types.GET_BLOG_TAGS_GENERAL;
    } 
    else if(articleType == articleTypes.unsigned) {
        return types.GET_BLOG_TAGS_UNSIGNED;
    }
    else {
        return types.GET_BLOG_TAGS_DISCOVER;
    }
};

const getActionTypeSections = (articleType) => {
    if(articleType == articleTypes.general) {
        return types.GET_BLOG_SECTIONS_GENERAL;
    } 
    else if(articleType == articleTypes.unsigned) {
        return types.GET_BLOG_SECTIONS_UNSIGNED;
    }
    else {
        return types.GET_BLOG_SECTIONS_DISCOVER;
    }
};

function clearItems(articleType) {
    let type;
    if(articleType === articleTypes.general) {
        type = types.CLEAR_BLOG_GENERAL;
    } 
    else if(articleType === articleTypes.unsigned) {
        type = types.CLEAR_BLOG_UNSIGNED;
    }
    else {
        type = types.CLEAR_BLOG_DISCOVER;
    }
    return { type };
}

export function getPosts(articleType, page = 1, section = null, tags = []) {
    return (dispatch, getState) => {
        const state = getState();
        const blogState = state.blog[articleType];
        const requestingNextPage = page > blogState.lastPage;
        const blogItems = blogState.items;
        let sections = [];
        if(section) {
            sections.push(section);
        }
        const searchChanged = JSON.stringify(sections) != JSON.stringify(blogState.selectedSections) || JSON.stringify(tags) != JSON.stringify(blogState.selectedTags);
        if(blogItems.length == 0 || requestingNextPage || searchChanged) {      
            if(!requestingNextPage) {
                dispatch(clearItems(articleType));
            }  
            dispatchStatusUpdate(dispatch, getActionTypeStatus(articleType), page, 'LOADING');
            let fetchTask = blogService.getPosts(articleType, page, sections, tags)
                .then(data => {
                    if(data) {
                        const results = {
                            lastPage: data.CurrentPage,
                            haveNextPage: data.CurrentPage < data.TotalPages,
                            items: data.Items,
                            selectedSections: sections,
                            selectedTags: tags
                        };
                        if(results) {
                            dispatch({ type: getActionTypeSet(articleType), results });
                            dispatchStatusUpdate(dispatch, getActionTypeStatus(articleType), page, 'LOADED');
                        }
                        return results;
                    }
                    else {
                        return null;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, getActionTypeStatus(articleType), page, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getSections(articleType) {
    return (dispatch, getState) => {
        const state = getState();
        const blogState = state.blog[articleType];
        const sections = blogState.sections;
        if(sections.length == 0) {        
            let fetchTask = blogService.getSections(articleType)
                .then(sections => {
                    if(sections) {
                        dispatch({ type: getActionTypeSections(articleType), sections });                        
                    }
                    return sections;                    
                })
                .catch(error => {
                    throw(error);
                });
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return new Promise((resolve, reject) => resolve(sections));
        }
    };
}

export function getTags(articleType) {
    return (dispatch, getState) => {
        const state = getState();
        const blogState = state.blog[articleType];
        const tags = blogState.tags;
        if(tags.length == 0) {        
            let fetchTask = blogService.getTags(articleType)
                .then(tags => {
                    if(tags) {
                        dispatch({ type: getActionTypeTags(articleType), tags });                        
                    }
                    return tags;                    
                })
                .catch(error => {
                    throw(error);
                });
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return new Promise((resolve, reject) => resolve(tags));
        }
    };
}

export function getArticle(link) {
    return (dispatch, getState) => {
        const state = getState();
        if(!state.blog.article || state.blog.article.Link.toLowerCase() !== link.toLowerCase()) {      
            dispatchArticleStatusUpdate(dispatch, types.GET_ARTICLE_STATUS, 'LOADING');
            let fetchTask = blogService.getArticle(link)
                .then(article => {
                    if(article) {                           
                        dispatch({ type: types.GET_ARTICLE, article });
                        dispatchArticleStatusUpdate(dispatch, types.GET_ARTICLE_STATUS, 'LOADED');
                        const linkPrefix = article.ArticleType.toLowerCase() === articleTypes.general ? 'Blog' : article.ArticleType;
                        const url = ShareService.getAbsoluteUrl(`/${linkPrefix}/${article.Link}`);
                        dispatch(getArticleShares(url, article));
                        return article;
                    }
                    else {
                        return null;
                    }
                })
                .catch(error => {
                    dispatchArticleStatusUpdate(dispatch, types.GET_ARTICLE_STATUS, 'FAILED');
                    //throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getArticleShares(url, article) {
    return (dispatch, getState) => {
        let fetchTask = blogService.getArticleShares(url)
            .then(data => {
                if(data) {
                    const shares = { link: article.Link, shareCount: data.ShareCount};
                    dispatch({ type: types.GET_ARTICLE_SHARES, shares });                        
                    return shares;                    
                }
                else {
                    return null;
                }
            })
            .catch(error => {
                throw(error);
            });
        addTask(fetchTask);
        return fetchTask;
    };
}